import { Component, Input, OnInit } from '@angular/core';
import { IOrder, IOrderItem } from '../../services/sale.service';

@Component({
  selector: 'order-item-summary',
  templateUrl: './order-item-summary.component.html',
  styleUrls: ['./order-item-summary.component.scss'],
})
export class OrderItemSummaryComponent implements OnInit{
  @Input() item: IOrderItem | undefined;
  @Input() order: IOrder | undefined;

  constructor() {}
  ngOnInit(): void {
  }

  public get isDelivery() {
    if(this.order) {
      return this.order.orderType === 'order.retailDelivery' || this.order.orderType === 'order.ecomSpecialDelivery' || this.order.orderType === 'order.ecomDelivery'; 
    } else {
      return false;
    }
  }

  public get name(): string {
    if(this.order) {
      return this.item.name;
    } else {
      return '';
    }
  }
  
  public get size(): string {
    if(this.order) {
      return this.item.size;
    } else {
      return '';
    }
  }

  public get color(): string {
    if(this.order) {
      return this.item.color;
    } else {
      return '';
    }
  }
}
